<template>
    <div class="bbWithdrawal">
        <bBWithdrawal :hostroletype="hostroletype" :hostroleinnerid="hostroleinnerid"></bBWithdrawal>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import BBWithdrawal from 'views/orderMgt/finance/Withdrawal.vue'
export default {
    name: 'Withdrawal',
    props: ['hostroletype', 'hostroleinnerid'],
    data() {
        return {
        }
    },
    mounted() {},
    methods: {
        ...mapActions([])
    },
    watch: {},
    filters: {},
    computed: {},
    components: {
        BBWithdrawal
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
</style>
